import {userData} from 'src/configs/OAuthConfig';
const useGetLoginUserType = () => {
  const user = userData();
  let userType = user && user?.profile?.userGroup;
  return {userType};
};

export default useGetLoginUserType;
